import React, { ReactElement } from 'react';
import NewBenefit from '../Benefits/NewBenefit';
import './ReaderBenefitsStrip.scss';

export function ReaderBenefitsStrip(): ReactElement {
    return (
        <div className='ReaderBenefitsStrip'>
            <NewBenefit />
        </div>
    );
}
